import React from 'react';
import SearchFilter from '../../common/search-filter/SearchFilter';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { changeCode, REDUCER_NAME } from './reducer';
import { withComponentId } from './../../common/ComponentIdContext';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from './../../app/commonReducer';

const getListSearchFromRedux = state => [
  ...state[COMMON_REDUCER_NAME].listOrganizationSearch,
  ...state[COMMON_REDUCER_NAME].listDerivative,
];

class Search extends React.Component {
  clickItemSearch = currentSearch => {
    const { changeCode, componentId } = this.props;

    changeCode(currentSearch, componentId);
  };

  getCurrentSearch = () => {
    const {
      condition,
      listOrganizationByOrganCode,
      listDerivativeByDerivativeCode,
    } = this.props;

    return (
      { ...listOrganizationByOrganCode, ...listDerivativeByDerivativeCode }[
        condition.code
      ] || condition
    );
  };

  render() {
    return (
      <SearchFilter
        schema={[
          { key: 'displayCode', className: 'w-20' },
          { key: 'codeName', className: 'w-55 text-truncate' },
          {
            key: 'exchange',
            className: 'w-25 text-right',
            render: text => text.toUpperCase(),
          },
        ]}
        listKeyFilter={['displayCode', 'codeName']}
        getListSearchFromRedux={getListSearchFromRedux}
        currentSearch={this.getCurrentSearch()}
        mainKey={'code'}
        sortKey={'displayCode'}
        clickItemSearch={this.clickItemSearch}
      />
    );
  }
}

const mapStateToProps = (state, { componentId }) => {
  return {
    condition: state[REDUCER_NAME].listMultiComponent[componentId].condition,
    listOrganizationByOrganCode:
      state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
    listDerivativeByDerivativeCode:
      state[COMMON_REDUCER_NAME].listDerivativeByDerivativeCode,
  };
};

const mapDispatchToProps = {
  changeCode,
};

export default compose(
  withComponentId,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(Search);
